document.addEventListener('DOMContentLoaded', function() {

  // sliders
	const mainSlider = document.querySelector('.product__main-slider'),
				thumbSlider = document.querySelector('.product__thumb-slider');

	let swiperMain,
			swiperThumb;

	swiperThumb = new Swiper(thumbSlider, {
		slidesPerView: 'auto',
		spaceBetween: 10,

		slideToClickedSlide: true,

		watchSlidesVisibility: true,
		watchSlidesProgress: true,

		threshold: 10,
		shortSwipes: false
	});

	swiperMain = new Swiper(mainSlider, {
		thumbs: {
			swiper: swiperThumb
		},
		pagination: {
			el: mainSlider.querySelector('.product__mainSliderPagination'),
			clickable: true
		},
		navigation: {
			nextEl: '.product__main-slider-btn--right',
			prevEl: '.product__main-slider-btn--left',
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		slideToClickedSlide: true
	});


  // full size mode
	// const slides = document.querySelectorAll('.item__main-slide'),
				mainSliderWrp = document.querySelector('.product__gallery'),
				mainSliderToggleBtn = document.querySelector('.product__closeSliderBtn');
	
	function toggleSlider() {
    if (mainSliderWrp.classList.contains('product__gallery--opened')) {
      mainSliderWrp.classList.remove('product__gallery--opened');
		  document.body.style.overflow = '';
    } else {
      mainSliderWrp.classList.add('product__gallery--opened');
		  document.body.style.overflow = 'hidden';
    }

		swiperMain.update();
	}

	// slides.forEach(slide => {

	// 	slide.addEventListener('click', function(){
	// 		mainSliderWrp.classList.add('item__main-slider-wrp--fixed');
	// 		document.body.style.overflow = 'hidden';

	// 		swiperMain.update();
	// 	});
	// });

	mainSliderToggleBtn.addEventListener('click', function(){
		toggleSlider();
	});

	document.addEventListener('keyup', function(e){

		if (e.keyCode == 27) {
			toggleSlider();
		}
	});
});